import { render, staticRenderFns } from "./BbsGroup.vue?vue&type=template&id=74bf8ee8&scoped=true&"
import script from "./BbsGroup.vue?vue&type=script&lang=js&"
export * from "./BbsGroup.vue?vue&type=script&lang=js&"
import style0 from "./BbsGroup.vue?vue&type=style&index=0&id=74bf8ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf8ee8",
  null
  
)

export default component.exports